import CommonNotificationsList from './CommonNotificationsList'

export default CommonNotificationsList
